import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import NumberCounter from "./NumberCounter/NumberCounter";
// import WhatWeDo from "./WhatWeDo/WhatWeDo";
// import MissionVision from "./MissionVision/MissionVision";
import FeaturedPrograms from "./FeaturedPrograms/FeaturedPrograms";
import Partners from "./Partners/Partners";
// import CTABanner from "./CTABanner/CTABanner";
import Volunteer from "./Volunteer/Volunteer";
import DonateCTA from "../Donate/DonateCTA";

const Home = () => {
  return (
    <>
      <HeroSection />
      <Volunteer/>
      <NumberCounter />
      <FeaturedPrograms />
      <Partners />
      <DonateCTA
        variant="purple"
        headline="Help Us Spread Kindness Further"
        subtext="Your generous contribution powers our programs, feeds communities, and empowers thousands of young volunteers across India."
      />
    </>
  );
};

export default Home;
